import { IStepComponentProps } from "@shared/components/form/types";
import { ActivityName } from "app/_modules/core/types";
import { MeasurementForm } from "app/_modules/core/components/forms";
import { TMeasurementResponse } from "app/_modules/pathways/entities";

export interface IMeasurementManualStepContext {
  activityName: ActivityName;
  onSubmitStart: () => void;
  onSubmitSuccess: (result: TMeasurementResponse) => void;
  onSubmitError: () => void;
}

export const MeasurementManualStep = ({ context }: IStepComponentProps<undefined, IMeasurementManualStepContext>) => {
  const activityName = context?.activityName!;
  const onSubmitStart = context?.onSubmitStart!;
  const onSubmitSuccess = context?.onSubmitSuccess!;
  const onSubmitError = context?.onSubmitError!;

  return (
    <MeasurementForm
      activityName={activityName}
      onSubmitStart={onSubmitStart}
      onSubmitSuccess={onSubmitSuccess}
      onSubmitError={onSubmitError}
    />
  );
};

export default MeasurementManualStep;
